<script setup>
import { ref } from "vue";
import { useRouter } from 'vue-router';
import WorkfileBody from '@/components/workfile/body/WorkfileBody.vue';
import LocalStorage from '@/controller/LocalStorage.js';
import { useWorkfilesStore } from '@/stores/workfiles.js';

const props = defineProps({
  fastFilter: String
});

const router = useRouter();
const workfilesStore = useWorkfilesStore();
const workfile = ref({});
const path =  router.currentRoute.value.params.id;
const userKey = ref(LocalStorage.getKey());
const loading = ref(false);
function getWorkfile() {
  loading.value = true;
  workfilesStore
    .fetchWorkfile({ k: userKey.value, id: path })
    .then((res) => {
      if (res.errors){
          router.push({ name: "notFound" })
          return;
      }
      if (res) {
        workfile.value = res;
        loading.value = false;
      } else if (res.errors && res.errors[0].error == 'INVALID_TOKEN') {
        router.push('/logout');
      }
      return 0;
    })
    .catch((err) => {
    });
}
getWorkfile();



</script>

<template>
    <div class="workfile-detail">
        <WorkfileBody :workfile="workfile" @download-media="handleDownloadMedia"/>
    </div>
</template>

<style lang="scss">
.workfile-detail{
  background-color: #EFF3F3;
  padding: 1rem 3rem 3rem 3rem;
  min-height: 91.2dvh;
}

@media (max-width:576px) {
  .workfile-detail{
    padding-top: 7dvh;
    overflow-y: visible;
    overflow-x: hidden;
    height: auto;

  }
}
@media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
 .workfile-detail {
      padding: 1rem 3rem 3rem 4rem;
  }
}

@media (min-width:1368px) and (max-width: 1900px) and (orientation: landscape) {
  .workfile-detail {
      padding: 1rem 3rem 3rem 5.3rem;
  }
}

@media (min-width: 577px) and (max-width: 1280px) and (orientation: portrait) {
    .workfile-detail{
      padding: 1rem 2rem 3rem 2rem;
    }
}

</style>